import React, { useEffect } from 'react';
import Footer from './components/common/Footer.js';
import Hero from './components/home/Hero.js';
import HowItWorks from './components/home/HowItWorks.js';
import FinalCta from './components/home/FinalCta.js';

export default function Home() {
  useEffect(() => {
    if (window.location.hash === '#reserve') {
      document.getElementById('reserve')?.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <main>
      <Hero />
      <HowItWorks />
      <FinalCta />
      <Footer />
    </main>
  );
}
